/* eslint-disable @typescript-eslint/no-unnecessary-condition */
import { CircularProgress, Stack, Typography } from "@mui/material";
import { useScrapLoadingLayout } from "components/scrapEyeLabelling/hooks/useScrapLoadingLayout";
import { ScrapEyeLayoutMap } from "components/scrapEyeLayout/ScrapEyeLayoutMap";
import { useScrapEyeMetadata } from "contexts/scrapEyeMetadata";
import { useTenantTranslation } from "hooks/formatters";
import { useMaterialColor, useMaterials } from "hooks/useMaterials";
import { useMemo } from "react";
import { useParams } from "react-router";

export const ScrapLoadingLayoutGuide = () => {
  const { t } = useTenantTranslation();
  const { location } = useParams<{ location: string }>();
  const { layout, layoutType, isLoading } = useScrapLoadingLayout(location);
  const { default_area_materials: defaultAreaMaterials } =
    useScrapEyeMetadata();
  const { materials } = useMaterials();
  const { getColor } = useMaterialColor();

  const areaMaterials = useMemo(() => {
    const labels: Record<string, string> = {};
    for (const [area, materialName] of Object.entries(
      defaultAreaMaterials ?? {}
    )) {
      const material = materials?.find(({ name }) => name === materialName);
      labels[area] = material?.labelling_name ?? materialName;
    }
    return labels;
  }, [defaultAreaMaterials, materials]);

  const areaColors = useMemo(() => {
    const colors: Record<string, string> = {};
    for (const [area, materialName] of Object.entries(
      defaultAreaMaterials ?? {}
    )) {
      const color = getColor(materialName);
      if (color) {
        colors[area] = color;
      }
    }
    return colors;
  }, [defaultAreaMaterials, getColor]);

  if (isLoading) {
    return <CircularProgress />;
  }
  if (!layout || !layoutType) {
    return null;
  }

  return (
    <Stack spacing={3}>
      <Typography variant="h6">{t("scrapLoadingLayout")}</Typography>

      <Typography variant="body1">{layout.description}</Typography>
      <Typography variant="body2" fontWeight="bold">
        {t("scrapAvailabilityNote")}
      </Typography>

      <ScrapEyeLayoutMap
        location={location}
        areaColors={areaColors}
        areaMaterials={areaMaterials}
      />
    </Stack>
  );
};
